import { useState } from "react"

import { pluralize } from "web/services/inflector"
import { isNonEmptyArray } from "web/services/helpers"

import routes from "web/routes/constants"

import Header from "./Header"
import Asset from "./Asset"
import Deal from "./Deal"

export default function DealLocationCard({
  primarySubject,
  location,
  assets,
  assetIds = [],
  deals,
  dealIds = [],
  onItemClick,
  onSelectionChanged,
  onClose,
}) {
  const haveAssets = isNonEmptyArray(assets)
  const haveDeals = isNonEmptyArray(deals)

  const numberOfAssets = haveAssets ? assets.length : assetIds.length
  const numberOfDeals = haveDeals ? deals.length : dealIds.length

  const showToggle = numberOfAssets + numberOfDeals > 1
  const selectionEnabledInHeader = numberOfDeals === 1

  const [expandedIndex, setExpandedIndex] = useState(numberOfAssets)

  function goToObject(subjectType, id) {
    if (onItemClick) {
      onItemClick(subjectType, id)
    } else {
      window.Turbo.visit(routes.tlo(pluralize(subjectType), "all", null, id))
    }
  }

  return (
    <div
      className="mb-4 flex w-64 cursor-pointer flex-col rounded-md bg-white pb-2 shadow-altrio-1"
      style={{ maxHeight: "calc(60vh - 80px)" }}
    >
      <Header
        title={primarySubject.name}
        location={location}
        primarySubject={primarySubject}
        selectionEnabled={selectionEnabledInHeader}
        onSelectionChanged={onSelectionChanged}
        onClick={() => goToObject("deal", primarySubject.id)}
        onClose={onClose}
      />
      <div className="flex-grow overflow-y-auto">
        {(haveAssets ? assets : assetIds).map((el, i) => {
          return (
            <Asset
              key={i}
              asset={haveAssets ? el : undefined}
              assetId={!haveAssets ? el : undefined}
              location={location}
              showToggle={showToggle}
              isExpanded={expandedIndex === i}
              selectionEnabled={false}
              onToggle={() => setExpandedIndex(i)}
              onClick={() => goToObject("asset", haveAssets ? el.id : el)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
        {(haveDeals ? deals : dealIds).map((el, i) => {
          const dealIndex = numberOfAssets + i

          return (
            <Deal
              key={i}
              deal={haveDeals ? el : undefined}
              dealId={!haveDeals ? el : undefined}
              showToggle={showToggle}
              isExpanded={expandedIndex === dealIndex}
              selectionEnabled={!selectionEnabledInHeader} // TODO: change for others
              onToggle={() => setExpandedIndex(dealIndex)}
              onClick={() => goToObject("deal", haveDeals ? el.id : el)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
      </div>
    </div>
  )
}
